import { render, staticRenderFns } from "./basic.vue?vue&type=template&id=2c44e25c&scoped=true"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44e25c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c44e25c')) {
      api.createRecord('2c44e25c', component.options)
    } else {
      api.reload('2c44e25c', component.options)
    }
    module.hot.accept("./basic.vue?vue&type=template&id=2c44e25c&scoped=true", function () {
      api.rerender('2c44e25c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/enterprise/info/basic.vue"
export default component.exports